"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_paper_1 = require("react-native-paper");
const react_native_1 = require("react-native");
const styles_1 = __importDefault(require("../../styles/styles"));
const defaultProps = {
    onChange: () => { },
};
const Toggle = ({ text, value, onChange }) => (react_1.default.createElement(react_native_1.View, null,
    react_1.default.createElement(react_native_1.View, { style: [styles_1.default.alignCenterCenter, styles_1.default.flexDirectionRow] },
        react_1.default.createElement(react_native_paper_1.Title, { style: [styles_1.default.textColorGray, styles_1.default.marginTen, styles_1.default.fontSizeText] }, text),
        react_1.default.createElement(react_native_paper_1.Switch, { onValueChange: onChange, value: value }))));
Toggle.defaultProps = defaultProps;
exports.default = Toggle;
